import styled from "styled-components";
const fontSize = localStorage.getItem("fontSize");

export const Title = styled.span`
  left: 133px;
  top: 434px;
  line-spacing: 1rem;
  line-height: 1rem;
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 700;
  font-size: 3rem;
  /* or 103% */
  /* white */
  color: #ffffff;
`;

export const RangeContainer = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
  gap: 1px;
`;

export const TimeRange = styled.input`
  border-radius: 8px;
  color: #101e8e;
  width: 30%;
  height: 3px;
  background: #eee;
  &:webkit-slider-thumb {
    display: none;
  }
`;
